import React from 'react';
import styles from './Header.module.css';
import phone from '../assets/phonep1.png';
import google from '../assets/google.png';
import apple from '../assets/apple.png';

function Header() {
  return (
    <header className={styles.header}>
      <div className={styles.navbar}>
        <span>KIPA</span>
          <nav>
            <a href="#features">Funksjoner</a>
            <a href="#licenses">Lisenser</a>
            <a href="#contact">Support</a>
            <a href="#footer">Kontakt</a>
          </nav>
      </div>
      <div className={styles.hero}>
        <div className={styles.left}>
          <h1>KIPA</h1>
          <p>KIPA eller (kunstig intelligente personlige assistent) er en app utviklet<br />for å samle forskjeldige ki funksjoner i samme app.</p>
          <div className={styles.appButtons}>
            <a href="https://play.google.com/store/apps/details?id=com.markusliland.AIHR" target="_blank" rel="noopener noreferrer">
              <img src={google} alt="Get on Google Play" className={styles.storeButton} />
            </a>
            <a href="../assets/google.png" target="_blank" rel="noopener noreferrer">
              <img src={apple} alt="Download on the App Store" className={styles.storeButton} />
            </a>
          </div>
        </div>
        <div className={styles.right}>
          <img src={phone} alt="La KI skrive teksten" className={styles.cardImageLow} />
        </div>
      </div>
      <div className={styles.heroPhone}>
        <div className={styles.left}>
          <h1>KIPA</h1>
          <p>KIPA eller (kunstig intelligente personlige assistent) er en app utviklet<br />for å samle forskjeldige ki funksjoner i samme app.</p>
          <img src={phone} alt="La KI skrive teksten" className={styles.cardImageLow} />
          <div className={styles.appButtons}>
            <a href="https://play.google.com/store/apps/details?id=com.markusliland.AIHR" target="_blank" rel="noopener noreferrer">
              <img src={google} alt="Get on Google Play" className={styles.storeButton} />
            </a>
            <a href="../assets/google.png" target="_blank" rel="noopener noreferrer">
              <img src={apple} alt="Download on the App Store" className={styles.storeButton} />
            </a>
          </div>
        </div>
      </div>

      {/* First Wave */}
      <div className={`${styles.wave} ${styles.wavePrimary}`}>
        <svg viewBox="0 0 1440 320" xmlns="http://www.w3.org/2000/svg">
          <path
            fill="#F3F3FB"
            d="M0,36L60,30C120,24,240,12,360,42C480,72,600,144,720,186C840,228,960,240,1080,234C1200,228,1320,204,1440,180C1560,156,1680,132,1800,126C1920,120,2040,132,2160,120C2280,108,2400,72,2520,48C2640,24,2760,12,2880,36C3000,60,3120,120,3240,144C3360,168,3480,156,3600,144C3720,132,3840,120,3960,102C4080,84,4200,60,4320,72C4440,84,4560,132,4680,132C4800,132,4920,84,5040,72C5160,60,5280,84,5400,102C5520,120,5640,132,5760,126C5880,120,6000,96,6120,114C6240,132,6360,192,6480,180C6600,168,6720,84,6840,78C6960,72,7080,144,7200,180C7320,216,7440,216,7560,228C7680,240,7800,264,7920,258C8040,252,8160,216,8280,210C8400,204,8520,228,8580,240L8640,252L8640,360L8580,360C8520,360,8400,360,8280,360C8160,360,8040,360,7920,360C7800,360,7680,360,7560,360C7440,360,7320,360,7200,360C7080,360,6960,360,6840,360C6720,360,6600,360,6480,360C6360,360,6240,360,6120,360C6000,360,5880,360,5760,360C5640,360,5520,360,5400,360C5280,360,5160,360,5040,360C4920,360,4800,360,4680,360C4560,360,4440,360,4320,360C4200,360,4080,360,3960,360C3840,360,3720,360,3600,360C3480,360,3360,360,3240,360C3120,360,3000,360,2880,360C2760,360,2640,360,2520,360C2400,360,2280,360,2160,360C2040,360,1920,360,1800,360C1680,360,1560,360,1440,360C1320,360,1200,360,1080,360C960,360,840,360,720,360C600,360,480,360,360,360C240,360,120,360,60,360L0,360Z"
          />
        </svg>
      </div>
      {/* Second Wave */}
      <div className={`${styles.wave} ${styles.waveSecondary}`}>
        <svg viewBox="0 0 1440 320" xmlns="http://www.w3.org/2000/svg">
          <path
            fill="#F3F3FB"
            d="M0,60L80,55C160,50,320,40,480,70C640,100,800,170,960,185C1120,200,1280,160,1440,145C1600,130,1760,140,1920,155C2080,170,2240,190,2400,210C2560,230,2720,250,2880,230C3040,210,3200,150,3360,135C3520,120,3680,150,3840,160C4000,170,4160,160,4320,150C4480,140,4640,130,4800,120C4960,110,5120,100,5280,90C5440,80,5600,70,5760,90C5920,110,6080,160,6240,150C6400,140,6560,70,6720,65C6880,60,7040,120,7200,120C7360,120,7520,60,7680,65C7840,70,8000,140,8160,150C8320,160,8480,110,8640,85C8800,60,8960,60,9120,75C9280,90,9440,120,9600,150C9760,180,9920,210,10080,190C10240,170,10400,100,10560,95C10720,90,10880,150,11040,190C11200,230,11360,250,11440,260L11520,270L11520,300L11440,300C11360,300,11200,300,11040,300C10880,300,10720,300,10560,300C10400,300,10240,300,10080,300C9920,300,9760,300,9600,300C9440,300,9280,300,9120,300C8960,300,8800,300,8640,300C8480,300,8320,300,8160,300C8000,300,7840,300,7680,300C7520,300,7360,300,7200,300C7040,300,6880,300,6720,300C6560,300,6400,300,6240,300C6080,300,5920,300,5760,300C5600,300,5440,300,5280,300C5120,300,4960,300,4800,300C4640,300,4480,300,4320,300C4160,300,4000,300,3840,300C3680,300,3520,300,3360,300C3200,300,3040,300,2880,300C2720,300,2560,300,2400,300C2240,300,2080,300,1920,300C1760,300,1600,300,1440,300C1280,300,1120,300,960,300C800,300,640,300,480,300C320,300,160,300,80,300L0,300Z"
          ></path>
        </svg>
      </div>
      {/* Third Wave */}
      <div className={`${styles.wave} ${styles.waveTertiary}`}>
        <svg viewBox="0 0 1440 320" xmlns="http://www.w3.org/2000/svg">
          <path
            fill="#F3F3FB"
            d="M0,69L80,92C160,115,320,161,480,161C640,161,800,115,960,95.8C1120,77,1280,84,1440,99.7C1600,115,1760,138,1920,130.3C2080,123,2240,84,2400,80.5C2560,77,2720,107,2880,122.7C3040,138,3200,138,3360,134.2C3520,130,3680,123,3840,115C4000,107,4160,100,4320,111.2C4480,123,4640,153,4800,145.7C4960,138,5120,92,5280,65.2C5440,38,5600,31,5760,26.8C5920,23,6080,23,6240,34.5C6400,46,6560,69,6720,99.7C6880,130,7040,169,7200,184C7360,199,7520,192,7680,187.8C7840,184,8000,184,8160,184C8320,184,8480,184,8640,180.2C8800,176,8960,169,9120,153.3C9280,138,9440,115,9600,92C9760,69,9920,46,10080,53.7C10240,61,10400,100,10560,107.3C10720,115,10880,92,11040,84.3C11200,77,11360,84,11440,88.2L11520,92L11520,230L11440,230C11360,230,11200,230,11040,230C10880,230,10720,230,10560,230C10400,230,10240,230,10080,230C9920,230,9760,230,9600,230C9440,230,9280,230,9120,230C8960,230,8800,230,8640,230C8480,230,8320,230,8160,230C8000,230,7840,230,7680,230C7520,230,7360,230,7200,230C7040,230,6880,230,6720,230C6560,230,6400,230,6240,230C6080,230,5920,230,5760,230C5600,230,5440,230,5280,230C5120,230,4960,230,4800,230C4640,230,4480,230,4320,230C4160,230,4000,230,3840,230C3680,230,3520,230,3360,230C3200,230,3040,230,2880,230C2720,230,2560,230,2400,230C2240,230,2080,230,1920,230C1760,230,1600,230,1440,230C1280,230,1120,230,960,230C800,230,640,230,480,230C320,230,160,230,80,230L0,230Z"
          ></path>
        </svg>
      </div>

      <div className={`${styles.particle} ${styles.particle1}`}></div>
      <div className={`${styles.particle} ${styles.particle2}`}></div>
      <div className={`${styles.particle} ${styles.particle3}`}></div>
      <div className={`${styles.particle} ${styles.particle4}`}></div>

      <div className={`${styles.particle} ${styles.particle5}`}></div>
      <div className={`${styles.particle} ${styles.particle6}`}></div>
      <div className={`${styles.particle} ${styles.particle7}`}></div>
      <div className={`${styles.particle} ${styles.particle8}`}></div>
      
      <div className={styles.featureList}>
        <div className={styles.feature}>
          <p className={styles.topText}>Enkel å bruke</p>
          <p className={styles.infoText}>Vi har designet appen slik at du enkelt kan navigere forstå og bruke den. Alt du trenger, på en måte som er lett å forstå.</p>
        </div>
        <div className={styles.feature}>
          <p className={styles.topText}>UI/UX</p>
          <p className={styles.infoText}>Vi har designet appen slik at du enkelt kan navigere forstå og bruke den. Alt du trenger, på en måte som er lett å forstå.</p>
        </div>
        <div className={styles.feature}>
          <p className={styles.topText}>Velg funksjoner å bruke</p>
          <p className={styles.infoText}>Vi har designet appen slik at du enkelt kan navigere forstå og bruke den. Alt du trenger, på en måte som er lett å forstå.</p>
        </div>
        <div className={styles.feature}>
          <p className={styles.topText}>Rask brukerstøtte</p>
          <p className={styles.infoText}>Vi har designet appen slik at du enkelt kan navigere forstå og bruke den. Alt du trenger, på en måte som er lett å forstå.</p>
        </div>
      </div>
    
    </header>
  );
}

export default Header;
